<template>
  <div
    class="h-full flex flex-col items-center justify-center pb-10 overflow-y-scroll"
  >
    <div class="text-secondary font-bold text-2xl">
      {{ $t("privacy-policy-title") }}
    </div>
    <div
      class="text-secondary mt-8"
      v-html="$t('privacy-policy-all', { legalName, fiscalAddress, taxId })"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "PolicyPage",
  data() {
    return {};
  },
  async mounted() {
    await this.refreshSignupInfo();
  },
  computed: {
    ...mapState(authStore, ["branding", "organization"]),
    legalName() {
      if (this.organization.id === "96137331-1054-4f1e-8215-43e7507bc1ee") {
        return "OAKBERRY S.L.";
      } else if (
        this.organization.id === "7ddc745f-295e-4340-9376-dad8543dc95b"
      ) {
        return "AMAGATALL CAFE I JOCS S.L.";
      } else {
        return this.organization.name;
      }
    },
    taxId() {
      if (this.organization.id === "96137331-1054-4f1e-8215-43e7507bc1ee") {
        return "B12345678";
      } else if (
        this.organization.id === "954b5b13-ce63-45da-bb24-6618aa3c1b03"
      ) {
        return "A12345678";
      } else if (
        this.organization.id === "7ddc745f-295e-4340-9376-dad8543dc95b"
      ) {
        return "B21971833";
      } else {
        return null;
      }
    },
    fiscalAddress() {
      if (this.organization.id === "96137331-1054-4f1e-8215-43e7507bc1ee") {
        return "Calle del Gral Oraá, 29, 28006 Madrid, España";
      } else if (
        this.organization.id === "954b5b13-ce63-45da-bb24-6618aa3c1b03"
      ) {
        return "Calle de Serrano, 41, 28001 Madrid, España";
      } else if (
        this.organization.id === "7ddc745f-295e-4340-9376-dad8543dc95b"
      ) {
        return "Carrer germans fontabals 5, Spain, l’ametlla del valles, Cataluña, 08480";
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapActions(authStore, ["refreshSignupInfo"]),
  },
};
</script>

<style scoped></style>
